import Flickity from 'flickity'

export default () => {
    resetDraggable()
    fixResize()
}

/**
 * Resets draggable state ontouchstart, in case ontouchend didn't fire.
 * See: https://github.com/metafizzy/flickity/issues/257
 */
function resetDraggable () {
    Flickity.prototype.ontouchstart = (function (original) {
        return function (event) {
            this._pointerUp(event, event.changedTouches[0])
            original.apply(this, arguments)
        }
    }(Flickity.prototype.ontouchstart))
}

/**
 * Fix resize
 */
function fixResize () {
    Flickity.prototype._createResizeClass = function () {
        this.element.classList.add('flickity-resize')
    }

    Flickity.createMethods.push('_createResizeClass')

    let resize = Flickity.prototype.resize
    Flickity.prototype.resize = function () {
        this.element.classList.remove('flickity-resize')
        resize.call(this)
        this.element.classList.add('flickity-resize')
    }
}

export function fixMobileSwipe (el) {
    let $el = $(el)

    $el.on('dragStart.flickity', function (event, pointer) {
        document.ontouchmove = function (e) {
            e.preventDefault()
        }
    })

    $el.on('dragEnd.flickity', function (event, pointer) {
        document.ontouchmove = function (e) {
            return true
        }
    })
}
